import React from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import MoreLink from './MoreLink';
import { dateRange, isMeetLive } from './meetDates';

// "What's on": upcoming meets as a strip of date blocks. Five across on
// desktop, three on tablets, a stacked list on phones.
const DateStripTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  const live = items.map((item) => isMeetLive(item));
  const next = live.indexOf(false);

  return (
    <>
      <div className="asaj-dates">
        {items.map((item, index) => {
          const { range, year } = dateRange(item.start, item.end);
          return (
            <ConditionalLink
              key={item['@id']}
              item={item}
              condition={!isEditMode}
              className="asaj-date"
            >
              <span className="asaj-db">
                {range}
                <small>{year}</small>
              </span>
              <span className="asaj-date-title">{item.title}</span>
              {live[index] && <span className="asaj-pill live">Live now</span>}
              {index === next && <span className="asaj-pill next">Next</span>}
            </ConditionalLink>
          );
        })}
      </div>
      <MoreLink
        linkTitle={linkTitle}
        linkHref={linkHref}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default DateStripTemplate;
